import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  CardProps,
  Chip,
  Stack,
  Typography
} from '@mui/material'
import { generatePath, Link as RouterLink } from 'react-router-dom'

import { AppRoutes } from '../../models'
import {
  InspectionEntry,
  InspectionExpanded,
  RepairOrderWithRelated
} from '../../sdk'
import { describeLicense, describeVehicleYMM } from '../../utils'
import { NotesButtonOfInspection } from '../DviSingleInspection/components/NotesButtonOfInspection'

type Props = {
  inspection: InspectionEntry
  inspectionExpanded?: InspectionExpanded
  repairOrder: RepairOrderWithRelated | undefined
} & CardProps

export const inspectionCardActionArea = (
  started: boolean,
  completed: boolean
) => (
  <Box>
    {started ? (
      completed ? (
        <Chip label="Completed" color="primary" variant="outlined" />
      ) : (
        <Chip label="In Progress" color="info" variant="outlined" />
      )
    ) : (
      <Chip label="Available" color="success" variant="outlined" />
    )}
  </Box>
)

function InspectionCard({
  inspection,
  repairOrder,
  inspectionExpanded,
  ...cardProps
}: Props) {
  const url = generatePath(AppRoutes.DVI_SINGLE_INSPECTION_SUMMARY, {
    id: inspection.id!
  })
  const vehicle = repairOrder?.vehicle!

  return (
    <Card
      sx={{
        border: '1px solid rgba(0, 0, 0, 0.24)',
        boxShadow: 0
      }}
      {...cardProps}>
      <CardActionArea component={RouterLink} to={url}>
        <CardHeader
          title={describeVehicleYMM(vehicle?.info!)}
          titleTypographyProps={{
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            overflow: 'hidden'
          }}
          subheader={
            repairOrder?.repairOrder
              ? `RO# ${repairOrder?.repairOrder!.localId}`
              : 'RO# Loading...'
          }
          action={inspectionCardActionArea(
            inspection.info?.started !== undefined,
            inspection.info?.finished !== undefined
          )}
          sx={{ '& .MuiCardHeader-content': { overflow: 'hidden' } }}
        />
        <CardContent>
          <Stack
            direction="row"
            justifyContent={'space-between'}
            alignItems={'flex-end'}>
            <Stack spacing={1}>
              <Typography variant="subtitle1">
                {inspection.info!.title!}
              </Typography>
              <Typography>
                {repairOrder?.vehicle!.info
                  ? `Plate: ${
                      describeLicense(repairOrder?.vehicle!.info!) || '-'
                    }`
                  : 'Plate: Loading...'}
              </Typography>
              <Typography>
                Created: {inspection.created?.toLocaleDateString()}
              </Typography>
            </Stack>
            {inspectionExpanded && (
              <Box>
                <NotesButtonOfInspection inspection={inspectionExpanded} />
              </Box>
            )}
          </Stack>
        </CardContent>
      </CardActionArea>
    </Card>
  )
}

export default InspectionCard
